// extracted by mini-css-extract-plugin
module.exports = {"Master":"Table_Master__3-S86","Break":"Table_Break__1qdGl","Row":"Table_Row__2cRdP","First":"Table_First__3xkRs"};